import React from 'react'
import { Typography, CardContent, Card } from '@mui/material'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import FolderZipIcon from '@mui/icons-material/FolderZip'
import { useTranslation } from 'react-i18next'

type DownloadCardProps = {
  bucketName: string
  fileName: string
  region: string
  titleKey: string
  fileType: 'pdf' | 'zip'
}

const DownloadCard: React.FC<DownloadCardProps> = ({
  bucketName,
  fileName,
  region,
  titleKey,
  fileType
}) => {
  const { t } = useTranslation()
  const handleDownload = () => {
    const url = `https://${bucketName}.s3.${region}.amazonaws.com/${fileName}`
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  const renderIcon = () => {
    if (fileType === 'zip') {
      return <FolderZipIcon sx={{ color: '#1976d2', fontSize: '150px' }} />
    }
    return <PictureAsPdfIcon sx={{ color: '#A11E20', fontSize: '150px' }} />
  }

  return (
    <Card
      onClick={handleDownload}
      sx={{
        width: '280px',
        height: '348px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2,
        borderRadius: 1,
        boxShadow: 1,
        border: '2px solid',
        borderColor: '#7C7C7C',
        cursor: 'pointer',
        transition: 'border-color 0.3s, border-width 0.3s',
        '&:hover': {
          borderColor: 'primary.main',
          borderWidth: 2,
          '& .MuiTypography-root': {
            fontWeight: '600',
            color: 'primary.main',
            lineHeight: '19.6px'
          }
        }
      }}
    >
      <CardContent sx={{ textAlign: 'center' }}>
        {renderIcon()}
        <Typography
          variant='body1'
          sx={{
            marginTop: '20px',
            lineHeight: '19.6px',
            textAlign: 'center'
          }}
        >
          {t(titleKey)}
        </Typography>
      </CardContent>
    </Card>
  )
}

export default DownloadCard
